import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RtdbListenerService } from '@app/_services/rtdb-listener.service';
import { SettingsService } from '@app/_services/settings.service';

@Component({
    selector: 'app-rate-limit-banner',
    standalone: true,
    imports: [CommonModule],
    template: `
        @if (isVisible()) {
            <div class="rate-limit-banner">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none"/>
                    <path d="M12 8v5M12 15h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <span>{{ ss.t('rateLimitBanner') }}</span>
            </div>
        }
    `,
    styles: [`
        .rate-limit-banner {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 10px 16px;
            background-color: rgba(255, 152, 0, 0.15);
            color: #ff9800;
            font-size: 13px;
            font-weight: 500;
            border-bottom: 1px solid rgba(255, 152, 0, 0.3);
            animation: slideDown 0.3s ease-out;
        }

        svg {
            flex-shrink: 0;
        }

        @keyframes slideDown {
            from {
                transform: translateY(-100%);
                opacity: 0;
            }
            to {
                transform: translateY(0);
                opacity: 1;
            }
        }
    `]
})
export class RateLimitBannerComponent {
    private rtdbListener = inject(RtdbListenerService);
    ss = inject(SettingsService);

    // Rate limiting now uses the full-screen blocked page (BlockedPageComponent).
    // This banner is kept for backward compatibility but is effectively disabled.
    isVisible(): boolean {
        return false;
    }
}
